// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCfQSicvy2gl-SKgqiinfTTeegicXVlnug",
  authDomain: "nzpainting.firebaseapp.com",
  projectId: "nzpainting",
  storageBucket: "nzpainting.firebasestorage.app",
  messagingSenderId: "1026236676894",
  appId: "1:1026236676894:web:77adb358ce100a35fe670f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };